import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const DatasetItemSchema_ = z.object({
  initializationInputId: zExt.objectId(), // Reference to LlmInitializationInput
  originalThreadId: zExt.objectId(), // For backlinking to original thread
  expectedOutput: z.string(), // First assistant response from original thread
  notes: z
    .string()
    .optional()
    .nullable()
    .transform((val) => val ?? undefined), // User notes about this input/output pair
  addedAt: z.date(), // When this item was added to the dataset
});

export const DatasetItemSchema: z.ZodType<DatasetItem> = DatasetItemSchema_;
export interface DatasetItem extends z.infer<typeof DatasetItemSchema_> {}

const AgentDatasetSchema_ = z.object({
  _id: zExt.objectId(),

  // Dataset Identity
  name: z.string(),
  description: z
    .string()
    .optional()
    .nullable()
    .transform((val) => val ?? undefined),
  agentName: z.string(),

  // Selected Input/Output Pairs
  items: z.array(DatasetItemSchema),

  // Metadata
  team: zExt.objectId(),
  createdBy: zExt.objectId(), // User who created the dataset
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const AgentDatasetSchema: z.ZodType<AgentDataset> = AgentDatasetSchema_;
export interface AgentDataset extends z.infer<typeof AgentDatasetSchema_> {}
